module.exports = __webpack_public_path__ + "img/symbol-15-left.5e184d8f.png";